import SvgIcon, { type SvgIconProps } from 'LuxKit/SvgIcon'
import styled, { keyframes } from 'styled-components'

const SPARKLES_GRADIENT_ID = 'hamburger-ai-sparkles-gradient'
const SPARKLES_ANIMATION_DURATION = '4s'

const sparklePulse = keyframes`
  0%, 100% {
    transform: scale(0.65);
  }

  25%, 75% {
    transform: scale(1.25);
  }

  50% {
    transform: scale(0.65);
  }
`

const SparklePath = styled.path<{ $delay: string }>`
  transform-box: fill-box;
  transform-origin: center;
  animation: ${sparklePulse} ${SPARKLES_ANIMATION_DURATION} ease-in-out infinite;
  animation-delay: ${props => props.$delay};

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    transform: scale(1);
  }
`

function AnimatedSparklesIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
      <defs>
        <linearGradient id={SPARKLES_GRADIENT_ID} x1="0" y1="0" x2="0" y2="24" gradientUnits="userSpaceOnUse">
          <stop stopColor="#7EFFD4" />
          <stop offset="1" stopColor="#018063" />
        </linearGradient>
      </defs>
      <SparklePath
        $delay="-1s"
        fill={`url(#${SPARKLES_GRADIENT_ID})`}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.3418 2.40761C19.21 1.86413 18.437 1.86413 18.3053 2.40761L17.9426 3.90301C17.8956 4.09705 17.7441 4.24855 17.5501 4.2956L16.0547 4.65821C15.5112 4.79 15.5112 5.56294 16.0547 5.69473L17.5501 6.05734C17.7441 6.10439 17.8956 6.25589 17.9426 6.44993L18.3053 7.94534C18.437 8.48881 19.21 8.48881 19.3418 7.94534L19.7044 6.44993C19.7514 6.25589 19.9029 6.10439 20.097 6.05734L21.5924 5.69473C22.1359 5.56294 22.1359 4.79 21.5924 4.65821L20.097 4.2956C19.9029 4.24855 19.7514 4.09705 19.7044 3.90301L19.3418 2.40761Z"
      />
      <SparklePath
        $delay="0s"
        fill={`url(#${SPARKLES_GRADIENT_ID})`}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.75946 5.98315C8.045 4.80562 9.71971 4.80562 10.0052 5.98315L10.7909 9.2232C10.8929 9.64361 11.2211 9.97186 11.6415 10.0738L14.8816 10.8595C16.0591 11.145 16.0591 12.8197 14.8816 13.1052L11.6415 13.8909C11.2211 13.9929 10.8929 14.3211 10.7909 14.7415L10.0052 17.9816C9.71971 19.1591 8.045 19.1591 7.75946 17.9816L6.9738 14.7415C6.87186 14.3211 6.54361 13.9929 6.1232 13.8909L2.88315 13.1052C1.70562 12.8197 1.70562 11.145 2.88315 10.8595L6.1232 10.0738C6.54361 9.97186 6.87186 9.64361 6.9738 9.2232L7.75946 5.98315Z"
      />
      <SparklePath
        $delay="-2s"
        fill={`url(#${SPARKLES_GRADIENT_ID})`}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.3053 15.9076C18.437 15.3641 19.21 15.3641 19.3418 15.9076L19.7044 17.403C19.7514 17.597 19.9029 17.7485 20.097 17.7956L21.5924 18.1582C22.1359 18.29 22.1359 19.0629 21.5924 19.1947L20.097 19.5573C19.9029 19.6044 19.7514 19.7559 19.7044 19.9499L19.3418 21.4453C19.21 21.9888 18.437 21.9888 18.3053 21.4453L17.9426 19.9499C17.8956 19.7559 17.7441 19.6044 17.5501 19.5573L16.0547 19.1947C15.5112 19.0629 15.5112 18.29 16.0547 18.1582L17.5501 17.7956C17.7441 17.7485 17.8956 17.597 17.9426 17.403L18.3053 15.9076Z"
      />
    </SvgIcon>
  )
}

export default AnimatedSparklesIcon
